import { useParams } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { IMAGES } from "@/data/site";
import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { FileX } from "lucide-react";

export default function CustomPage() {
  const { slug } = useParams();
  const { pages, lang } = useApp();
  const page = (pages || []).find((p) => p.slug === slug);

  if (!page) {
    return (
      <div className="oj-container py-28 text-center" data-testid="custom-page-missing">
        <FileX className="w-12 h-12 text-teal-300 mx-auto mb-4" />
        <h1 className="text-2xl font-extrabold text-[#0B3B39]">Page not found</h1>
        <p className="mt-2 text-slate-500">This page may have been unpublished or removed.</p>
      </div>
    );
  }

  const title = lang === "hi" ? (page.title_hi || page.title) : page.title;
  const subtitle = lang === "hi" ? (page.subtitle_hi || page.subtitle) : page.subtitle;
  const body = lang === "hi" ? (page.body_hi || page.body) : page.body;
  const paras = String(body || "").split(/\n+/).map((s) => s.trim()).filter(Boolean);

  return (
    <div data-testid={`custom-page-${slug}`}>
      <PageHero image={page.hero_image || IMAGES.building} idBase={`custom_${slug}`} eyebrow="OOJJAS Corporate" title={title} subtitle={subtitle} />
      {paras.length > 0 && (
        <section className="oj-section">
          <div className="oj-container max-w-3xl">
            {paras.map((p, i) => (
              <Reveal key={`${i}-${p.slice(0, 16)}`} delay={i * 0.05}>
                <p className="text-slate-600 leading-relaxed mb-5 text-lg">{p}</p>
              </Reveal>
            ))}
          </div>
        </section>
      )}
    </div>
  );
}
